var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right-drawer",style:({
  width: _vm.value ? _vm.width : '0',
  
})},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }